import {ErrorHandler, Injectable, Injector, NgZone} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {MxPreloaderService} from 'mx-core';


export class RejectionError extends Error {
    public rejection: HttpErrorResponse;
}

// errors-handler.ts
@Injectable()
export class PrlErrorsHandler implements ErrorHandler {
    // Because the ErrorHandler is created before the providers, we’ll have to use the Injector to get them.
    constructor(private injector: Injector) {
    }

    handleError(error: Error | HttpErrorResponse | RejectionError) {

        // Log the error anyway
        console.error('Portal error: ', error);

        if (error instanceof HttpErrorResponse) {
            // Server or connection error happened
            this.redirectToErrorPage(error);
        } else if ((<RejectionError>error).rejection) {
            this.redirectToErrorPage((<RejectionError>error).rejection);
        } else {
            // Handle Client Error (Angular Error, ReferenceError...)
        }

    }

    private redirectToErrorPage(error: HttpErrorResponse): void {
        const router = this.injector.get(Router);
        const zone = this.injector.get(NgZone);
        const preloaderService = this.injector.get(MxPreloaderService);
        if (!navigator.onLine) {
            // TODO consider call Lior's notification service
            // Handle offline error
            // return notificationService.notify('No Internet Connection');
        } else {
            // Handle Http Error (error.status === 403, 404...)
            // return notificationService.notify(`${error.status} - ${error.message}`);
            if ([404, 403, 500, 503, 504].some(v => v === error.status)) {
                // TODO consider call Lior's notification service instead
                if (router.navigate) {
                    zone.run(() => router.navigate(['/' + error.status]));
                    preloaderService.hide();
                }
            }
        }
    }
}
